import { siteApiSlice } from "../../../app/siteApiSlice";

export interface DraftList {
	formalFullName: string;
	drafts: UserTestRow[];
}

export interface UserTestRow {
	id: number;
	dateTime: Date;
	promptTitle: string;
	status: string;
}

export interface UserViewDraftHistories {
	draftHistories: DraftHistory[];
}

export interface DraftHistory {
	id: number;
	length: number;
	status: string;
	statusDescription: string;
	savedOn: Date | null;
}

export interface DraftHistoryContent {
	format: string;
	content: string;
	markup: string;
}

export const draftAutosaveHistoryApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		viewDrafts: build.query<DraftList, { writerId: number; courseId: number }>({
			query: ({ writerId, courseId }) => ({
				url: `/User/ViewDraftsForCourseSpa?writerId=${writerId}&courseId=${courseId}`,
			}),
			providesTags: ["WritingHistory"],
		}),
		viewDraftHistories: build.query<UserViewDraftHistories, { draftId: number }>({
			query: ({ draftId }) => ({
				url: `/User/ViewDraftHistories?id=${draftId}`,
			}),
			providesTags: ["WritingHistory"],
		}),
		draftHistoryContent: build.query<DraftHistoryContent, { historyId: number }>({
			query: ({ historyId }) => ({
				url: `/User/DraftHistory?id=${historyId}`,
				method: "POST",
			}),
			providesTags: ["WritingHistory"],
		}),
	}),
});

export const { useViewDraftsQuery, useViewDraftHistoriesQuery, useDraftHistoryContentQuery } =
	draftAutosaveHistoryApiSlice;
